import { currency } from '../utils';

const PRICING = {
  audience: {
    free: 0,
    bronze: 0,
    silver: 0,
    gold: 0,
  },
  emailAddOn: {
    free: 0,
    bronze: 0,
    silver: 0,
    gold: 0,
  },
  phoneAddOn: {
    free: 0,
    bronze: 0,
    silver: 0,
    gold: 0,
  },
  ipAddOn: {
    free: 0,
    bronze: 0,
    silver: 0,
    gold: 0,
  },
  identifierBundleAddOn: {
    free: 0,
    bronze: 0,
    silver: 0,
    gold: 0,
  },
  digitalUseAddOn: {
    free: 0,
    bronze: 0,
    silver: 0,
    gold: 0,
  },
  subscriptions: {
    free: {
      monthly: 0,
      quarterly: 0,
    },
    bronze: {
      monthly: 499,
      quarterly: 1197.6,
    },
    silver: {
      monthly: 1000,
      quarterly: 2400,
    },
    gold: {
      monthly: 'Custom',
      quarterly: 'Custom',
    },
  },
  insights: {
    free: {
      base: 0,
      discount: 0,
    },
    bronze: {
      base: 0,
      discount: 0.15,
    },
    silver: {
      base: 0,
      discount: 0.3,
    },
    gold: {
      base: 0,
      discount: 1,
    },
  },
  enhancements: {
    free: {
      discount: 0,
    },
    bronze: {
      discount: 0,
    },
    silver: {
      discount: 0.15,
    },
    gold: {
      discount: 0.3,
    },
  },
};

export const getProductRate = (product, plan) => {
  return PRICING[product]?.[plan];
};

export const calculateProductPrice = (product, quantity, plan) => {
  const rate = PRICING[product]?.[plan];

  if (!rate) return 0;

  return quantity * rate;
};

export const calculateEmailAddOnPrice = (numEmails, plan) => {
  const rate = PRICING.emailAddOn[plan];

  if (!rate) return 0;

  return numEmails * rate;
};

export const getSubscriptionPrice = (plan, recurringInterval) => {
  return PRICING.subscriptions[plan]?.[recurringInterval];
};

export const calculateInsightPrice = (plan) => {
  const planPricing = PRICING.insights[plan];

  if (!planPricing) return 500;

  return planPricing.base * (1 - planPricing.discount);
};

export const getInsightDiscount = (plan) => {
  const planPricing = PRICING.insights[plan];

  if (!planPricing) return 0;

  return planPricing.discount;
};

export const calculateEnhancementPackageRate = (
  rate,
  plan = 'free'
): number => {
  try {
    const parsedRate = parseFloat(rate);
    const pricing = PRICING.enhancements[plan];
    return parsedRate * (1 - pricing.discount);
  } catch (err) {
    console.error('Error parsing enhancement package rate', err);
    return 0;
  }
};

export const generateEnhancementPricePerRecord = (pricing, plan) => {
  const planPrice = pricing[plan || 'free'];
  return planPrice?.discount && planPrice?.base ? (
    <>
      <span className="line-through text-gray-400 mr-1">
        {currency(planPrice.base, 2, 4)}
      </span>
      {currency(planPrice.base * (1 - planPrice.discount), 2, 4)}* / record
    </>
  ) : (
    `$${planPrice} / record`
  );
};

export const calculateTotalEnhancementPricePerRecord = (pricing, plan) => {
  const planPrice = pricing[plan || 'free'];
  return planPrice?.discount && planPrice?.base
    ? planPrice.base * (1 - planPrice.discount)
    : planPrice;
};

export const generateTotalEnhancementPrice = (
  pricing,
  plan,
  recordsMatched
) => {
  return currency(
    calculateTotalEnhancementPrice(pricing, plan, recordsMatched)
  );
};

export const calculateTotalEnhancementPrice = (
  pricing,
  plan,
  recordsMatched
) => {
  const planPrice = pricing[plan || 'free'];
  const rate =
    planPrice?.discount && planPrice?.base
      ? planPrice.base * (1 - planPrice.discount)
      : planPrice;
  return recordsMatched * rate;
};

export const roundTotalPrice = (price) => Math.round(price * 100) / 100;
